import { useAuth, User } from 'oidc-react'
import { FC } from 'react'

import { Redirect, Route, RouteProps } from 'react-router-dom'

interface Props extends RouteProps {
    forbiddenUrl?: string
}

export const GuardedRoute: FC<Props> = ({
    forbiddenUrl = '/',
    ...props
}) => {
    
    // TODO: Validar roles

    const auth = useAuth()
    const role = auth?.userData?.profile.role as string[]

    if(!auth?.userData) {
        return <Redirect to={"/user"}/>
    }
    
    if(!role || (!role.includes("SSO.SuperAdmin")
    && !role.includes("SSO.Admin")) ) {
        return <Redirect to={forbiddenUrl}/>
    }

    return (
        <Route {...props}/>
    )
}